import React, { useRef, useState } from 'react';
import { IOrders } from '../../pages/Dashboard/order.types';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import Button from '../Button/Button';
import { useTranslation } from 'react-i18next';
import { buttonPrintStyle } from '../../pages/Dashboard/components/DrawerOrderItem/styles';
import usePrinter from '../../hooks/usePrinter';
import { LANG_TEXT } from '../../constants/language';

function PrintButton({ data, toggleDrawer }: { data: IOrders; toggleDrawer?: (open: boolean) => void }) {
  const { t } = useTranslation();
  const { addToQueue } = usePrinter();
  const [isPrintProcessing, setIsPrintProcessing] = useState(false);
  const lastPrintClickRef = useRef<number>(0);
  const PRINT_CLICK_THROTTLE_MS = 1000;

  return (
    <>
      <Button
        id="print_button"
        fullWidth={false}
        title={t(LANG_TEXT.PRINT_RECEIPT)}
        buttonStyle={buttonPrintStyle}
        sxTextStyle={{ color: 'var(--Gray-700, #344054)', fontWeight: 600, lineHeight: '20px', width: 'max-content' }}
        onClick={() => {
          const now = Date.now();
          if (lastPrintClickRef.current > 0 && now - lastPrintClickRef.current < PRINT_CLICK_THROTTLE_MS) {
            return;
          }
          lastPrintClickRef.current = now;
          setIsPrintProcessing(true);
          try {
            toggleDrawer?.(false);
            const queuedData = { ...data, foods: (data as IOrders).all_foods ?? (data as IOrders).foods };
            addToQueue({
              data: queuedData,
              type: 'manual',
            });
          } finally {
            setTimeout(() => setIsPrintProcessing(false), PRINT_CLICK_THROTTLE_MS);
          }
        }}
        disable={isPrintProcessing}
        startIcon={<LocalPrintshopIcon sx={{ color: 'rgba(52, 64, 84, 1)' }} />}
      />
    </>
  );
}

export default PrintButton;
